module.exports = __webpack_public_path__ + "media/assets/icons/ignite-logo-e9e9ad2766dff1262e7e66f5f5472fe8.svg";